import { styled } from "styled-components";

// Container for the entire patients section
export const Container = styled.div`
  min-height: calc(100% - 71px);
  background: ${({ theme }) => theme.COLORS.WHITE};
  padding: ${({ theme }) => theme.PADDING.XL};

  @media (max-width: 759px) {
    padding: 8px 16px;
  }
`;

// Error message styling for selection errors
export const SelectionError = styled.div`
  margin-left: 20px;
  color: ${({ theme }) => theme.COLORS.ERROR};
  font-size: 18px;
  font-weight: bold;
`;

// Container for search fields
export const SearchFields = styled.div`
  display: flex;
  row-gap: 16px;
  flex-wrap: wrap;
  height: auto;
  width: 1000px;
  margin-bottom: 32px;
  align-items: center;
`;

export const FilterContainer = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

// Individual search field
export const SearchFieldWrapper = styled.div`
  padding-right: 24px;
  flex-grow: 30%;
`;
